import React from 'react';
import { Modal, Box, Typography, Grid, Paper } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 1000,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh',
  overflow: 'auto',
  borderRadius: '12px',
  border: '1px solid rgba(0, 0, 0, 0.1)'
};

const detailItemStyle = {
  padding: '16px',
  marginBottom: '12px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    transform: 'translateY(-2px)'
  }
};

const labelStyle = {
  color: '#666',
  fontSize: '0.875rem',
  fontWeight: 600,
  marginBottom: '4px'
};

const valueStyle = {
  color: '#333',
  fontSize: '1rem',
  fontWeight: 500
};

const headerStyle = {
  marginBottom: '24px',
  paddingBottom: '16px',
  borderBottom: '2px solid #f0f0f0'
};

export default function Modalviewer({ name, chosen, view, setfalser, details = {} }) {
  return (
    <Modal
      open={view}
      onClose={setfalser}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography 
          id="modal-modal-title" 
          variant="h5" 
          component="h2" 
          sx={headerStyle}
          color="primary"
        >
          {name} Details
        </Typography>
        
        <Grid container spacing={3}>
          {Object.entries(details).map(([label, value]) => (
            <Grid item xs={12} md={6} key={label}>
            <Paper sx={detailItemStyle}>
                <Typography sx={labelStyle}>{label}</Typography>
                <Typography sx={valueStyle}>{value}</Typography>
            </Paper>
          </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
}